document.addEventListener("DOMContentLoaded", function () {
    (function () {
        "use strict";

        const classNames = {
            active: "is-active",
            table: "[data-table]",
            convert: "convert",
            rawValue: "rawValue",
            inchValue: "inchValue",
            rowSelector: "c-sizing-pages__row-selector"
        };

        const elements = {
            convertButtons: document.querySelectorAll("[data-convert]"),
            cells: document.querySelectorAll(`${classNames.table} td`),
            rowSelector: document.querySelector(`.${classNames.rowSelector}`)
        };

        function initialize() {
            elements.cells.forEach((cell) => {
                const cellContent = cell.innerHTML.trim();
                cell.dataset[classNames.rawValue] = cellContent;

                const values = cellContent.split(" ");
                for (let i = 0; i < values.length; i++) {
                    if (values[i].endsWith("cm")) {
                        const cmValue = parseFloat(values[i].split("cm")[0]);
                        const inchValue = Math.round((cmValue / 2.54) * 100) / 100 + '"';
                        values[i] = inchValue;
                    }
                }

                cell.dataset[classNames.inchValue] = values.join(" ");
            });
            elements.convertButtons.forEach((button) => {
                button.addEventListener("click", () => {
                    if (!button.classList.contains(classNames.active)) {
                        const conversionType = button.dataset[classNames.convert];
                        if (conversionType) {
                            elements.convertButtons.forEach((otherButton) => {
                                if (otherButton.dataset[classNames.convert] === conversionType) {
                                    otherButton.classList.add(classNames.active);
                                } else {
                                    otherButton.classList.remove(classNames.active);
                                }
                            });

                            if (conversionType === "in") {
                                elements.cells.forEach((cell) => {
                                    cell.innerHTML = cell.dataset[classNames.inchValue];
                                });
                            } else {
                                elements.cells.forEach((cell) => {
                                    cell.innerHTML = cell.dataset[classNames.rawValue];
                                });
                            }
                        }
                    }
                });
            });
            if (elements.rowSelector) {
                const rows = document.querySelectorAll(`${classNames.table} tbody tr`);

                elements.rowSelector.addEventListener("change", (event) => {
                    const selectedIndex = parseInt(event.target.value);
                    rows.forEach((row, index) => {
                        if (index === selectedIndex) {
                            row.classList.add(classNames.active);
                        } else {
                            row.classList.remove(classNames.active);
                        }
                    });
                });
            }
        }

        initialize();
    })();
});